import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DealEventLogTab } from '@dealstack/frontend/app/pages/Project/DealEventLog/DealEventLog.types.ts';
import { parseDealEventLogTab } from '@dealstack/frontend/app/pages/Project/DealEventLog/utils/dealEventLogTabs.utils.ts';

export const DEAL_EVENT_LOG_TAB_PARAM = 'tab';

export const useDealEventLogTab = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const tab =
		parseDealEventLogTab(searchParams.get(DEAL_EVENT_LOG_TAB_PARAM)) ??
		DealEventLogTab.ALL_EVENTS;

	// The columns differ per tab, so a filter carried across would key on a column that is gone.
	const setTab = useCallback(
		(next: DealEventLogTab) => {
			const params = new URLSearchParams();

			if (next !== DealEventLogTab.ALL_EVENTS) {
				params.set(DEAL_EVENT_LOG_TAB_PARAM, next);
			}

			setSearchParams(params, { replace: true });
		},
		[setSearchParams]
	);

	return { tab, setTab };
};
